import React from 'react';
import logoImg from '../assets/rare-locals-logo.webp';

export default function Logo({ size = 'md', showText = true }) {
  const sizes = {
    xs: { img: 36, gap: 'gap-2', title: 'text-sm', tag: 'text-[8px]' },
    sm: { img: 48, gap: 'gap-2.5', title: 'text-base', tag: 'text-[9px]' },
    md: { img: 52, gap: 'gap-3', title: 'text-lg xl:text-xl', tag: 'text-[10px]' },
    'mobile-lg': { img: 52, gap: 'gap-2.5', title: 'text-base', tag: 'text-[10px]' },
    lg: { img: 88, gap: 'gap-3', title: 'text-2xl md:text-3xl', tag: 'text-[11px] md:text-xs' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center ${s.gap} select-none min-w-0`}>
      <img
        src={logoImg}
        alt="Rare Locals"
        width={s.img}
        height={s.img}
        style={{ width: s.img, height: s.img }}
        className="object-contain flex-shrink-0"
        loading="eager"
        decoding="async"
      />
      {showText && (
        <div className="flex-col leading-tight min-w-0 hidden sm:flex lg:hidden xl:flex">
          <span className={`font-serif-brand font-semibold tracking-[0.14em] text-brand-gold whitespace-nowrap ${s.title}`}>
            RARE LOCALS
          </span>
          <span className={`uppercase tracking-[0.18em] text-brand-gold-light/70 whitespace-nowrap hidden 2xl:block ${s.tag}`}>
            Rare in nature. Local at heart.
          </span>
        </div>
      )}
    </div>
  );
}
